import {
  getLevelButtonColor,
  MATURITY_LEVEL_LABELS,
} from "@/utils/maturity-colors";

type LevelButtonsProps = {
  selectedLevel: number | undefined;
  onSelect: (level: number) => void;
};

const LEVELS = [1, 2, 3, 4, 5] as const;

function LevelButtons({ selectedLevel, onSelect }: LevelButtonsProps) {
  return (
    <div
      className="flex gap-1.5"
      role="radiogroup"
      aria-label="Nivel maturitate"
    >
      {LEVELS.map((level) => {
        const { color, bg } = getLevelButtonColor(level);
        const isSelected = selectedLevel === level;

        return (
          <button
            key={level}
            type="button"
            role="radio"
            aria-checked={isSelected}
            aria-label={`Nivel ${level} — ${MATURITY_LEVEL_LABELS[level]}`}
            onClick={() => onSelect(level)}
            className="flex-1 py-3 rounded-lg transition-all duration-150 flex flex-col items-center gap-0.5"
            style={{
              backgroundColor: isSelected ? color : bg,
              outline: isSelected ? `2px solid ${color}` : `1px solid #E0E0E0`,
              outlineOffset: isSelected ? 2 : 0,
            }}
          >
            <span
              className="text-base font-bold leading-none"
              style={{ color: isSelected ? "#fff" : "#B0BEC5" }}
            >
              {level}
            </span>
            <span
              className="text-[9px] font-medium leading-none"
              style={{ color: isSelected ? "#fff" : "#CBD5E1" }}
            >
              {MATURITY_LEVEL_LABELS[level]}
            </span>
          </button>
        );
      })}
    </div>
  );
}

export default LevelButtons;
